<template>
  <div class="field">
    <label class="label" v-if="showLabel">{{ label }}</label>
    <div class="control is-fullwidth">
      <multiselect
        :showLabels="false"
        name="linkedDealer"
        data-vv-as="linked dealer"
        v-model="selectedDealer"
        :options="availableDealers"
        label="name"
        :allowEmpty="true"
        trackBy="id"
        :hideSelected="true"
        placeholder="None - Select a dealer...">
      </multiselect>
    </div>
    <p class="help" v-if="helpText">{{ helpText }}</p>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const mapDealerGetters = createNamespacedHelpers('dealer').mapGetters

export default {
  name: 'LinkedDealerSelector',
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'Linked Dealer'
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    helpText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedDealer: null
    }
  },
  computed: {
    ...mapDealerGetters(['allDealers']),
    availableDealers () {
      return this.allDealers || []
    }
  },
  watch: {
    selectedDealer (newValue) {
      this.$emit('input', newValue)
    },
    value (newValue) {
      this.selectedDealer = newValue
    }
  },
  mounted () {
    this.selectedDealer = this.value || null
  }
}
</script>
